import { configureStore } from "@reduxjs/toolkit";
import authSlice from "../feature/auth-slice";
import qcastSlice from "../feature/qcast-slice";
import recordSlice from "../feature/record-slice";
import respondSlice from "../feature/respond-slice";

const store = configureStore({
  reducer: {
    record: recordSlice,
    respond: respondSlice,
    qcast: qcastSlice,
    auth: authSlice
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({
    serializableCheck: false
  })
});

export default store;